export const sitesWebMisc = {
  // NombreEditable.vue — حقل اسم الموقع القابل للتحرير مباشرةً
  ne: {
    aria: "اسم موقعك الإلكتروني",
    placeholder: "مكان إقامتي",
    hint: "Enter للحفظ · Esc للتراجع",
  },

  // website/index.vue — معالج إنشاء الموقع
  website: {
    next: "التالي",
  },

  // Notificaciones/index.vue — الخط الزمني للإشعارات
  notif: {
    title: "الإشعارات",
    subtitle: "كل ما حدث في أماكن إقامتك، بترتيب زمني.",
    // عوامل التصفية
    filterAll: "الكل",
    filterBookings: "الحجوزات",
    filterCheckins: "تسجيلات الوصول",
    filterServices: "الخدمات",
    filterPayments: "المدفوعات",
    // الحالة الفارغة
    emptyAll: "لا توجد إشعارات بعد",
    emptyFilter: "لا توجد إشعارات في هذا الفلتر",
    emptyBody:
      "عند حدوث أي شيء في حجوزاتك —حجز جديد، تسجيل وصول، دفعة— سيظهر هنا.",
    // فواصل الأيام
    noDate: "بلا تاريخ",
    today: "اليوم",
    yesterday: "أمس",
    // حالة الحدث (العمود الأيسر)
    stNueva: "جديد",
    stActualizada: "محدَّث",
    stCancelada: "ملغى",
    stRealizado: "مكتمل",
    stSolicitado: "مطلوب",
    stRecibida: "وارد",
    stAprobada: "مقبول",
    stRechazada: "مرفوض",
    stConfirmado: "مؤكَّد",
    stEnProceso: "قيد الدفع",
    stAviso: "تنبيه",
    // فئة الحدث (العنوان الفرعي)
    catReserva: "حجز",
    catCheckin: "تسجيل وصول",
    catServicio: "خدمة",
    catSolicitud: "طلب",
    catPago: "دفع",
    catPagoPendiente: "دفع معلّق",
    catSistema: "نظام",
    // تسميات وصفية لنوع الحدث
    lbNuevaReserva: "حجز جديد",
    lbReservaActualizada: "حجز محدَّث",
    lbReservaCancelada: "حجز ملغى",
    lbCheckin: "تسجيل الوصول",
    lbServicio: "خدمة",
    lbSolicitud: "طلب",
    lbSolicitudAprobada: "طلب مقبول",
    lbSolicitudRechazada: "طلب مرفوض",
    lbPago: "دفعة",
    lbNotificacion: "إشعار",
  },

  // Integrations/index.vue — عمليات الربط مع الخدمات الخارجية
  integrations: {
    title: "عمليات الربط",
    subtitle: "اربط خدمات خارجية لتحسين الإدارة",
    descPricelabs: "تحسين ديناميكي للأسعار",
    descStripe: "تحصيل مدفوعات النزلاء بالبطاقة",
    descWompi: "تحصيل مدفوعات النزلاء في كولومبيا",
    connected: "متصل",
    disconnected: "غير متصل",
  },
};
